export const code = [
 
    // 亚洲地区
    {code:"+86", reg:"^\\+861[3-9]\\d{9}$|^\\+86(?:0\\d{2,3}-?)?\\d{7,8}$"}, // 中国
    {code:"+81", reg:"^\\+81(?:70|80|90)\\d{8}$|^\\+81[1-9]\\d{0,3}-\\d{1,4}-\\d{4}$"}, // 日本
    {code:"+82", reg:"^\\+82(?:10|11|16|17|18|19)\\d{7,8}$"}, // 韩国
    {code:"+65", reg:"^\\+65[689]\\d{7}$"}, // 新加坡
    {code:"+60", reg:"^\\+60(?:1[0-9]|2|3|4|5|6|7|8|9)\\d{7,8}$"}, // 马来西亚
    {code:"+66", reg:"^\\+66(?:2|3[2-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9])\\d{6,7}$"}, // 泰国
    {code:"+84", reg:"^\\+84(?:3[2-9]|5[2689]|7[06789]|8[1-9]|9[0-9])\\d{7}$"}, // 越南
    {code:"+91", reg:"^\\+91[6-9]\\d{9}$"}, // 印度
    {code:"+92", reg:"^\\+92(?:3[0-6]\\d|4[0-9]\\d|5[0-9]\\d|6[0-9]\\d|7[0-9]\\d|8[0-9]\\d|9[0-9]\\d)\\d{7}$"}, // 巴基斯坦
    {code:"+966", reg:"^\\+966(?:5|1[1-9])\\d{8}$"}, // 沙特阿拉伯
    {code:"+971", reg:"^\\+971(?:5[0-9]|2|3|4|6|7|9)\\d{7}$"}, // 阿联酋
    {code:"+972", reg:"^\\+972(?:5[0-9]|2|3|4|8|9)\\d{7}$"}, // 以色列
    {code:"+94", reg:"^\\+94(?:7[0-9]|1|2|3|4|5|6|8|9)\\d{7}$"}, // 斯里兰卡
    {code:"+95", reg:"^\\+95(?:9|1|2|3|4|5|6|7|8)\\d{7,9}$"}, // 缅甸
    {code:"+886", reg:"^\\+886(?:9|2|3|4|5|6|7|8)\\d{7,8}$"}, // 中国台湾
    {code:"+852", reg:"^\\+852[569]\\d{7}$"}, // 中国香港
    {code:"+853", reg:"^\\+853[6]\\d{7}$"}, // 中国澳门
    
    // 欧洲地区
    {code:"+44", reg:"^\\+44(?:1\\d{9}|2\\d{8}|7\\d{9})$"}, // 英国
    {code:"+49", reg:"^\\+49(?:1[5-7]|3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9])\\d{7,10}$"}, // 德国
    {code:"+33", reg:"^\\+33[1-9]\\d{8}$"}, // 法国
    {code:"+39", reg:"^\\+39(?:3[0-9]|4[0-9]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9[0-9])\\d{6,10}$"}, // 意大利
    {code:"+34", reg:"^\\+34[6789]\\d{8}$"}, // 西班牙
    {code:"+31", reg:"^\\+31(?:6|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9]|7[0-9]|8[0-9]|9[0-9])\\d{7,8}$"}, // 荷兰
    {code:"+41", reg:"^\\+41(?:7[5-9]|2[1-9]|3[1-9]|4[1-9]|5[1-9]|6[1-9]|8[1-9]|9[1-9])\\d{7}$"}, // 瑞士
    {code:"+43", reg:"^\\+43(?:6[60-90]|1|2[1-9]|3[1-9]|4[1-9]|5[1-9]|7[1-9]|8[1-9]|9[1-9])\\d{6,9}$"}, // 奥地利
    {code:"+32", reg:"^\\+32(?:4[6-9]|1[0-9]|2|3|4[2-5]|5[0-9]|6[0-9]|7[0-9]|8[0-9]|9)\\d{7,8}$"}, // 比利时
    {code:"+358", reg:"^\\+358(?:4[0-9]|5[0-9])\\d{7}$"}, // 芬兰
    {code:"+46", reg:"^\\+46(?:7[0-9]|1[0-9]|2[0-9]|3[0-9]|4[0-9]|5[0-9])\\d{6,8}$"}, // 瑞典
    {code:"+47", reg:"^\\+47[49]\\d{7}$"}, // 挪威
    {code:"+353", reg:"^\\+353(?:8[3-9]|1|2[1-9]|4[1-9]|5[1-9]|6[1-9]|7[1-9]|9[1-9])\\d{6,8}$"}, // 爱尔兰
    {code:"+351", reg:"^\\+351[9]\\d{8}$"}, // 葡萄牙
    {code:"+48", reg:"^\\+48[5-8]\\d{8}$"}, // 波兰
    {code:"+380", reg:"^\\+380(?:50|63|66|67|68|91|92|93|94|95|96|97|98|99)\\d{7}$"}, // 乌克兰
    {code:"+7", reg:"^\\+7(?:9[0-9]|8[1-9])\\d{8}$"}, // 俄罗斯
    
    // 美洲地区
    {code:"+1", reg:"^\\+1[2-9]\\d{2}[2-9]\\d{6}$"}, // 美国和加拿大
    {code:"+55", reg:"^\\+55(?:1[1-9]|2[12478]|3[1-578]|4[1-9]|5[1345]|6[1-9]|7[13-9]|8[1-9]|9[1-9])\\d{8,9}$"}, // 巴西
    {code:"+52", reg:"^\\+52(?:1|800)\\d{8,10}$"}, // 墨西哥
    {code:"+54", reg:"^\\+54(?:9|1[1-9])\\d{8,9}$"}, // 阿根廷
    {code:"+56", reg:"^\\+56(?:9|2|3|4|5|6|7)\\d{7,8}$"}, // 智利
    {code:"+57", reg:"^\\+57(?:3[0-9]|1|2|3|4|5|6|7|8|9)\\d{7,9}$"}, // 哥伦比亚
    {code:"+58", reg:"^\\+58(?:4[1-2]|2[1-9])\\d{8}$"}, // 委内瑞拉
    {code:"+506", reg:"^\\+506[8]\\d{7}$"}, // 哥斯达黎加
    {code:"+502", reg:"^\\+502[4-9]\\d{7}$"}, // 危地马拉
    {code:"+503", reg:"^\\+503[6-7]\\d{7}$"}, // 萨尔瓦多
    {code:"+504", reg:"^\\+504[9]\\d{7}$"}, // 洪都拉斯
    {code:"+505", reg:"^\\+505[8]\\d{7}$"}, // 尼加拉瓜
    {code:"+507", reg:"^\\+507[6]\\d{7}$"}, // 巴拿马
    
    // 非洲地区
    {code:"+27", reg:"^\\+27(?:6|7|8)\\d{8}$"}, // 南非
    {code:"+234", reg:"^\\+234(?:70|80|81|90|91)\\d{8}$"}, // 尼日利亚
    {code:"+20", reg:"^\\+20(?:1[0-46-9]|2)\\d{8}$"}, // 埃及
    {code:"+254", reg:"^\\+254(?:7|1)\\d{8}$"}, // 肯尼亚
    {code:"+251", reg:"^\\+251(?:9|1)\\d{8}$"}, // 埃塞俄比亚
    {code:"+233", reg:"^\\+233(?:2|5)\\d{8}$"}, // 加纳
    {code:"+258", reg:"^\\+258(?:8[2-5])\\d{7}$"}, // 莫桑比克
    {code:"+263", reg:"^\\+263(?:7[1-9])\\d{7}$"}, // 津巴布韦
    {code:"+243", reg:"^\\+243(?:8[1-9]|9[1-9])\\d{7}$"}, // 刚果民主共和国
    {code:"+221", reg:"^\\+221(?:7[7-8]|3|4|5|6|8|9)\\d{7}$"}, // 塞内加尔
    {code:"+216", reg:"^\\+216[2-9]\\d{7}$"}, // 突尼斯
    {code:"+213", reg:"^\\+213(?:5|6|7)\\d{8}$"}, // 阿尔及利亚
    {code:"+226", reg:"^\\+226[6-7]\\d{7}$"}, // 布基纳法索
    {code:"+250", reg:"^\\+250[7]\\d{8}$"}, // 卢旺达
    {code:"+260", reg:"^\\+260(?:9[5-9]|7[6-9])\\d{7}$"}, // 赞比亚
    {code:"+265", reg:"^\\+265(?:8|9)\\d{7}$"}, // 马拉维
    
    // 大洋洲地区
    {code:"+61", reg:"^\\+61(?:4\\d{8}|[2-9]\\d{7})$"}, // 澳大利亚
    {code:"+64", reg:"^\\+64(?:2\\d{7,9}|[34679]\\d{6,7})$"}, // 新西兰
    {code:"+679", reg:"^\\+679[9]\\d{6}$"}, // 斐济
    {code:"+682", reg:"^\\+682[7-8]\\d{5}$"}, // 库克群岛
    {code:"+689", reg:"^\\+689[8]\\d{6}$"}, // 法属波利尼西亚
    {code:"+670", reg:"^\\+670[3-9]\\d{5}$"}, // 东帝汶
    {code:"+674", reg:"^\\+674[7-8]\\d{5}$"}, // 瑙鲁
    {code:"+677", reg:"^\\+677[7-8]\\d{5}$"}, // 所罗门群岛
    {code:"+676", reg:"^\\+676[7-8]\\d{5}$"}, // 汤加
    {code:"+683", reg:"^\\+683[5-9]\\d{5}$"}, // 瓦努阿图
    {code:"+680", reg:"^\\+680[7-9]\\d{5}$"}, // 帕劳

]